<template>
  <main class="home">
    <about id="main" tabindex="0"></about>
    <twitch></twitch>
    <social></social>
    <youtube-section></youtube-section>
  </main>
</template>

<script>
import About from './home/About'
import Twitch from './home/Twitch'
import Social from './home/Social'
import YoutubeSection from './home/YoutubeSection'

export default {
  name: 'home',
  components: {
    About,
    Twitch,
    Social,
    YoutubeSection
  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 $standard-spacing;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Home.vue?916db18e